import { Directive, input, Signal, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dojoFilterSection]',
})
export class FilterSectionDirective {
  constructor(readonly templateRef: TemplateRef<unknown>) {}

  readonly name = input.required<string>({ alias: 'dojoFilterSection' });
  readonly label = input.required<string>();
  readonly count = input<number>(0);
  readonly clearFn = input<() => void>();
}

export interface FilterSectionData extends SingleFilterData {
  readonly name: string;
}

export interface SingleFilterData {
  readonly label: string;
  readonly count: number;
  readonly template: TemplateRef<unknown>;
  readonly clearFn?: () => void;
  readonly isSelected?: boolean | Signal<boolean>;
}
